import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Typography } from 'antd';
import React from 'react';
import { JournalLineKey, NominalMapping } from './constants';
import XeroNominalMappingForm from './XeroNominalMappingForm';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  mapping: NominalMapping;
  onChange: (mapping: NominalMapping) => void;
  requiredKeys: JournalLineKey[];
  missingKeys: JournalLineKey[];
  onContinue: () => void;
  loading?: boolean;
};

/**
 * NX-5235 — the nominal-code window the Jira flow opens after Apply.
 * Pure UI: the page owns all state and the Continue behaviour.
 */
const XeroNominalMappingModal: React.FC<Props> = ({
  isOpen,
  toggle,
  mapping,
  onChange,
  requiredKeys,
  missingKeys,
  onContinue,
  loading = false,
}) => {
  const { messages } = useTypedIntl();

  return (
    <AppModalContainer
      isOpen={isOpen}
      toggle={toggle}
      title={messages['accounting.xeroJournal.mappingTitle']}
      width={900}
      closable
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
          disabled: loading,
        },
        {
          name: messages['common.continue'],
          onClick: onContinue,
          loading,
          disabled: loading,
        },
      ]}
    >
      <div className="flex flex-col gap-4">
        <Typography.Text type="secondary">
          {messages['accounting.xeroJournal.mappingHint']}
        </Typography.Text>

        <XeroNominalMappingForm
          value={mapping}
          onChange={onChange}
          requiredKeys={requiredKeys}
          missingKeys={missingKeys}
          disabled={loading}
        />
      </div>
    </AppModalContainer>
  );
};

export default XeroNominalMappingModal;
